"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssetLibraryPage = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const admin_context_1 = require("@src/components/pages/admin/admin-context");
const react_router_dom_1 = require("react-router-dom");
const AssetLibrary_1 = require("@src/components/modules/AssetLibrary");
const premium_subscription_1 = require("@src/helpers/premium-subscription");
const AssetLibraryPage = () => {
    const { companyInfo } = (0, admin_context_1.useAdminContextValue)();
    const history = (0, react_router_dom_1.useHistory)();
    const hasActivePremiumSubscription = (0, premium_subscription_1.getHasCompanyActivePremiumCompanyProfileSubscription)(companyInfo.companyPaymentSubscriptions);
    react_1.default.useEffect(() => {
        if (!hasActivePremiumSubscription) {
            history.pushLocalized('/admin');
        }
    }, [hasActivePremiumSubscription]);
    return (0, jsx_runtime_1.jsx)(AssetLibrary_1.AssetLibrary, {});
};
exports.AssetLibraryPage = AssetLibraryPage;
